import { createContext, useContext } from 'react';

type SliderContextValue = {
  appClassnamePrefix: string;
  isDrag: boolean;
  isHovered: boolean;
  setHovered: (value: boolean) => void;
};

export const sliderContext = createContext<SliderContextValue>({
  appClassnamePrefix: 'es-app',
  isDrag: false,
  isHovered: false,
  setHovered: () => {}
});

export const useSlider = () => useContext(sliderContext);
